<template>
  <v-row>
    <!-- chart -->
    <v-col class="col-12">
      <chartjs-wrapper
        ref="chartJsWrapper"
        class="white"
        chartId="productTargetPricesChart"
        :chart-data="cashDeskPricesChartData"
        :type="'line'"
        :options="cashDeskPricesChartOptions"
        :chart-height="20"
        hover-line
        @click:element="clickedChartPoint"
      >
      </chartjs-wrapper>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DateRangeChartMixin from '@/components-internal/mixins/DateRangeChartMixin.js'
import _ from 'lodash'
import definitions from '../../../definitions'

export default Vue.extend({
  name: 'CashDeskPricesChart',

  mixins: [DateRangeChartMixin],

  props: {
    disableSlider: {
      required: false,
      type: Boolean,
      default: false,
    },
    selectedDefinitions: {
      required: true,
      type: Array,
    },
    cashDeskPrices: {
      required: true,
      type: Array,
    },
    pointRadius: {
      required: false,
      type: Number,
      default: definitions.globalChartSettings.pointRadius,
    },
  },

  computed: {
    cashDeskPricesChartData() {
      let data = {
        labels: [],
        datasets: [],
      }
      let linesData = _.groupBy(this.cashDeskPrices, 'productDefinitionId')
      for (let prodDefId in linesData) {
        const selection = _.find(
          this.selectedDefinitions,
          function (selection) {
            return selection.item.id === parseInt(prodDefId)
          }
        )
        let line = {
          lineTension: 0,
          data: [],
          /* global i18n */
          label: selection?.item?.getTranslatedName(),
          pointRadius: this.pointRadius,
          borderWidth: definitions.globalChartSettings.borderWidth,
          pointBackgroundColor: [],
          pointBorderColor: [],
          borderColor: selection?.color,
          backgroundColor: 'rgba(0, 0, 0, 0)',
        }
        linesData[prodDefId].forEach((cashDeskPrice) => {
          line.data.push(cashDeskPrice.getChartFormattedPrice())
          line.pointBackgroundColor.push('white')
          line.pointBorderColor.push(selection?.color)

          if (data.labels.length <= linesData[prodDefId].length) {
            data.labels.push(cashDeskPrice.date)
          }
        })
        data.datasets.push(line)
      }

      return data
    },
    cashDeskPricesChartOptions() {
      const mainOptions = {
        tooltips: {
          callbacks: {
            label: (tooltipItems, data) => {
              return (
                data.datasets[tooltipItems.datasetIndex].label +
                ': ' +
                tooltipItems.yLabel +
                ` ${store.getters
                  .getCurrentDestinationInstance()
                  .getCurrency()}`
              )
            },
          },
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.$t('cashDeskPriceChart.ylabel'),
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                min: this.dateRange.startDate,
                max: this.dateRange.endDate,
              },
              time: {
                unit: this.unit,
                stepSize: 1,
              },
            },
          ],
        },
      }
      return _.merge(this.baseChartOptions, mainOptions)
    },
  },
})
</script>
